// extracted by mini-css-extract-plugin
module.exports = {"FooterStyle":"FooterNavbar_FooterStyle__24YrW","footerNavbar":"FooterNavbar_footerNavbar__2n90j"};